export default __webpack_public_path__ + "static/media/arrow-down.35de9196.svg";